import {
  withSpinner,
  failure,
  success,
} from "../../../../redux/actions/utilities";
import { customToast, getAIResponseErrorMessage } from "../../../../shared";
import {
  successMessages,
  inboxReduxConstants,
  errorMessages,
  toastTypes,
} from "../../constants";
import { inboxServices } from "../../services";

const { INTERNAL_NOTES_SAVED } = successMessages;
const {
  AI_REQUEST_IN_PROGRESS,
  AI_REQUEST_IN_PROGRESS_RELOAD_THE_PAGE_OR_REOPEN_THE_POPUP,
} = errorMessages;

const {
  SEND_MESSAGE,
  RESET_CONVERSATION,
  SAVE_INTERNAL_NOTES,
  GENERATE_AI_RESPONSE,
  RESET_AI_RESPONSE,
  GET_ALL_CONVERSATIONS,
  GET_CUSTOMER_INSIGHTS,
  RESET_ALL_CONVERSATIONS,
  UPDATE_ALL_CONVERSATIONS,
  GET_CONVERSATION_MESSAGES,
  GET_PREVIEW_CUSTOMER_SURVEY,
  GET_PREVIOUS_INTERNAL_NOTES,
  GET_CONVERSATION_ORDER_DETAILS,
  GET_PREVIOUS_CONVERSATION_DATES,
  RESET_PREVIOUS_CONVERSATION_DATES,
  GET_CONVERSATION_BY_CONVERSATION_ID,
  UPDATE_CUSTOMER_CONVERSATION_MESSAGES,
} = inboxReduxConstants;

//Getting all conversations
const getAllConversations = (queryString, body, resetAllConversations) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_ALL_CONVERSATIONS, () =>
      inboxServices
        .getAllConversations(queryString, body)
        .then(
          (response) => {
            resetAllConversations?.();
            dispatch(success(response, GET_ALL_CONVERSATIONS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Getting conversation by conversation id
const getConversationMessages =
  (conversationId, { id, customerId }) =>
  (dispatch) => {
    withSpinner(dispatch, GET_CONVERSATION_MESSAGES, () =>
      inboxServices
        .getConversationMessages(conversationId || id)
        .then(
          (response) => {
            dispatch(
              success(
                {
                  ...response,
                  conversationId: conversationId || id,
                  customerId,
                },
                GET_CONVERSATION_MESSAGES
              )
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };

//Gettting previous conversation dates
const getPreviousConversationDates = (body) => (dispatch) => {
  withSpinner(dispatch, GET_PREVIOUS_CONVERSATION_DATES, () =>
    inboxServices
      .getPreviousConversationDates(body)
      .then(
        (response) => {
          dispatch(success(response, GET_PREVIOUS_CONVERSATION_DATES));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Reset previous conversation dates
const resetPreviousConversationDates = () => (dispatch) => {
  dispatch(success([], RESET_PREVIOUS_CONVERSATION_DATES));
};

//Update customer conversation
const updateConversation = (conversationId) => (dispatch) => {
  dispatch(success(conversationId, UPDATE_CUSTOMER_CONVERSATION_MESSAGES));
};

//Send Message
const sendConversationMessage = (data) => (dispatch) => {
  dispatch(success(data, SEND_MESSAGE));
};

//Update all conversations with signlR
const updateAllConversations = (data) => (dispatch) => {
  dispatch(success(data, UPDATE_ALL_CONVERSATIONS));
};

//Save internal notes
const saveInternalNotes = (data, toastDisplayFlag) => (dispatch) => {
  return withSpinner(dispatch, SAVE_INTERNAL_NOTES, () =>
    inboxServices
      .saveInternalNotes(data)
      .then(
        (response) => {
          dispatch(success(response, SAVE_INTERNAL_NOTES));
          if (toastDisplayFlag) {
            customToast(INTERNAL_NOTES_SAVED, toastTypes.SUCCESS);
          }
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          throw error;
        }
      )
  );
};

const generateAIResponse = (conversationId) => (dispatch) => {
  return withSpinner(dispatch, GENERATE_AI_RESPONSE, () =>
    inboxServices
      .generateAIResponse(conversationId)
      .then(
        (response) => {
          dispatch(success(response, GENERATE_AI_RESPONSE));
        },
        (error) => {
          const errorMessage = getAIResponseErrorMessage(
            error,
            AI_REQUEST_IN_PROGRESS_RELOAD_THE_PAGE_OR_REOPEN_THE_POPUP
          );
          customToast(errorMessage, toastTypes.ERROR);
          dispatch(failure({}, GENERATE_AI_RESPONSE));
          throw error;
        }
      )
  );
};

const reGenerateAIResponse = (responseAction, conversationId) => (dispatch) => {
  withSpinner(dispatch, GENERATE_AI_RESPONSE, () =>
    inboxServices
      .reGenerateAIResponse(responseAction, conversationId)
      .then(
        (response) => {
          dispatch(success(response, GENERATE_AI_RESPONSE));
        },
        (error) => {
          const errorMessage = getAIResponseErrorMessage(
            error,
            AI_REQUEST_IN_PROGRESS
          );
          customToast(errorMessage, toastTypes.ERROR);
        }
      )
  );
};

//Get preview customer survey
const getCustomerPreviewSurvey = (conversationId) => (dispatch) => {
  withSpinner(dispatch, GET_PREVIEW_CUSTOMER_SURVEY, () =>
    inboxServices
      .getPreviewCustomerSurvey(conversationId)
      .then(
        (response) => {
          dispatch(success(response, GET_PREVIEW_CUSTOMER_SURVEY));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Get previous internal notes
const getPreviousInternalNotes = (orderId) => (dispatch) => {
  withSpinner(dispatch, GET_PREVIOUS_INTERNAL_NOTES, () =>
    inboxServices
      .getPreviousInternalNotes(orderId)
      .then(
        (response) => {
          dispatch(success(response, GET_PREVIOUS_INTERNAL_NOTES));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Update internal note
const getCustomerInsights = (brandId, customerId) => (dispatch) => {
  withSpinner(dispatch, GET_CUSTOMER_INSIGHTS, () =>
    inboxServices
      .getCustomerInsights(brandId, customerId)
      .then(
        (response) => {
          dispatch(success(response?.data, GET_CUSTOMER_INSIGHTS));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          dispatch(failure({}, GET_CUSTOMER_INSIGHTS));
        }
      )
  );
};

//Update internal note
const getConversationByConversationId = (conversationId) => (dispatch) => {
  return withSpinner(dispatch, GET_CONVERSATION_BY_CONVERSATION_ID, () =>
    inboxServices
      .getConversationByConversationId(conversationId)
      .then(
        (response) => {
          dispatch(success(response?.data, GET_CONVERSATION_BY_CONVERSATION_ID));
          return response.data;
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          dispatch(failure({}, GET_CONVERSATION_BY_CONVERSATION_ID));
          throw error;
        }
      )
  );
};

//Get customer conversation order details by conversation id
const getConversationOrderDetails = (conversationId) => (dispatch) => {
  withSpinner(dispatch, GET_CONVERSATION_ORDER_DETAILS, () =>
    inboxServices
      .getConversationOrderDetails(conversationId)
      .then(
        (response) => {
          dispatch(success(response, GET_CONVERSATION_ORDER_DETAILS));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          dispatch(failure({}, GET_CONVERSATION_ORDER_DETAILS));
        }
      )
  );
};

//Reset allConversation state in reducer
const resetAllConversations = () => (dispatch) => {
  dispatch(success([], RESET_ALL_CONVERSATIONS));
};

//Reset conversation state in reducer
const resetConversation = () => (dispatch) => {
  dispatch(success({}, RESET_CONVERSATION));
};

const resetAiResponse = () => (dispatch) => {
  dispatch(success({}, RESET_AI_RESPONSE));
};

export const inboxActions = {
  resetAiResponse,
  resetConversation,
  saveInternalNotes,
  getAllConversations,
  generateAIResponse,
  updateConversation,
  getCustomerInsights,
  reGenerateAIResponse,
  resetAllConversations,
  updateAllConversations,
  getConversationMessages,
  sendConversationMessage,
  getPreviousInternalNotes,
  getCustomerPreviewSurvey,
  getConversationOrderDetails,
  getPreviousConversationDates,
  resetPreviousConversationDates,
  getConversationByConversationId,
};
